import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Button } from "@components/Button";
import { Notification } from "@components/Notification/Notification";
import { useBillInsuranceActivationModal } from "@hooks/useBillInsuranceActivationModal";
import type { TChubbBillInsuranceStatus } from "@services/insurance/types";

interface IChubbInsuranceNotificationProps {
  variant?: TChubbBillInsuranceStatus;
  jointBillServiceId?: number;
}

export const ChubbInsuranceNotification: React.FC<
  IChubbInsuranceNotificationProps
> = ({ variant = "default" }) => {
  const { t } = useTranslation();

  const { openBillInsuranceActivationModal } =
    useBillInsuranceActivationModal();

  return (
    <Notification
      title={t(`insuranceNotification.${variant}.title`)}
      description={t(`insuranceNotification.${variant}.description`)}
      imagePath="/images/notification/chubb-insurance-icon.png"
      variant="big"
      className={twMerge(
        "bg-green-light",
        variant === "default" && "bg-[#FFEDC1]",
      )}
      button={
        <>
          {variant === "default" && (
            <Button onClick={() => openBillInsuranceActivationModal()}>
              {t(`insuranceNotification.default.buttons.confirm`)}
            </Button>
          )}
        </>
      }
    />
  );
};
